module.exports = [{"type":"title","text":"2024-06-28"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"Perpetual New Interface: Query historical transaction details."}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2024-06-28.json
// module id = xM8g
// module chunks = 3